export function MediamarktTermsFR() {
  return (
    <article>
      <h1>Modalités et conditions</h1>

      <time dateTime="2024-09-01">Septembre 2024</time>

      <div>
        <h3>1. Général</h3>
        <p>
          Jotta AS (« Jottacloud ») propose un service de stockage dans le cloud
          (« Service ») qui vous permet de stocker, de sauvegarder, de
          synchroniser et de partager des fichiers sur Internet. Les présentes
          conditions d'utilisation (« Contrat »), ainsi que notre Politique de
          confidentialité, constituent un accord juridiquement contraignant
          entre Jottacloud et vous en tant qu'utilisateur. Les références à «
          nous », « notre » et « nos » font référence à Jottacloud, tandis que «
          vous », « votre » et « utilisateur » font référence à l'utilisateur.
          En utilisant le Service, vous acceptez et êtes lié par les termes du
          présent Contrat.
        </p>
        <h3>2. Compte utilisateur</h3>
        <p>
          Pour utiliser le Service, vous devez créer un compte Jottacloud. Les
          plans d'abonnement disponibles sont décrits dans l'aperçu des tarifs
          et des abonnements de Jottacloud. Généralement, les types d'abonnement
          incluent un compte gratuit, un compte personnel pour un utilisateur,
          un compte personnel pour plusieurs utilisateurs et un compte
          professionnel.
        </p>
        <h3>3. Compte gratuit</h3>
        <p>
          Un compte gratuit est fourni gratuitement avec des limites spécifiques
          en termes de capacité de stockage et de fonctionnalités. Jottacloud se
          réserve également le droit d'appliquer d'autres restrictions et
          d'afficher des publicités payantes sur les comptes gratuits. Un compte
          gratuit peut être résilié par Jottacloud s'il est inactif pendant une
          période d'un an ou plus.
        </p>
        <h3>4. Compte personnel avec un ou plusieurs utilisateurs</h3>
        <p>
          Un compte personnel avec un ou plusieurs utilisateurs est disponible
          exclusivement pour un usage privé individuel et non pour les
          entreprises, les organisations ou les entités similaires. Un compte
          personnel avec un ou plusieurs utilisateurs ne peut pas être utilisé
          pour stocker des données dans un contexte commercial et est doté d'une
          capacité de stockage et de fonctionnalités en fonction du plan
          d'abonnement choisi. Les comptes personnels comprennent à la fois des
          abonnements pour utilisateur unique et des abonnements partageables
          pour un maximum de cinq utilisateurs.
        </p>
        <p>
          Un compte personnel avec un ou plusieurs utilisateurs a une durée d'un
          ou douze mois et est ensuite automatiquement renouvelé pour une
          nouvelle période d'abonnement (un ou douze mois), sauf si
          l'utilisateur annule l'abonnement payant avant la fin de la période
          d'abonnement en cours. La carte de crédit de l'utilisateur est
          automatiquement débitée lors du renouvellement de l'abonnement. Les
          paiements ne sont pas remboursables, même si l'utilisateur annule.
          L'utilisateur peut annuler ou modifier son abonnement à tout moment.
          Lorsqu'un compte personnel avec plusieurs utilisateurs est créé, un
          administrateur est automatiquement créé.
        </p>
        <p>
          L'administrateur est responsable de l'ajout et de la gestion de
          l'abonnement et de ses membres. L'administrateur identifie les membres
          de l'abonnement en fournissant des adresses e-mail ou des numéros de
          téléphone portable pour chaque membre.
        </p>
        <p>
          En tant qu'administrateur, vous êtes responsable du paiement des frais
          d'utilisation de l'abonnement par tous les membres. L'administrateur
          d'un compte personnel comportant plusieurs utilisateurs n'a pas accès
          aux données stockées sur les comptes des membres à moins qu'elles ne
          soient partagées avec l'administrateur. Les membres n'ont accès qu'à
          leurs propres fichiers, sauf si d'autres membres ont partagé des
          fichiers avec eux. Les membres peuvent partager des données et des
          fichiers avec d'autres personnes.
        </p>
        <p>
          Un administrateur peut mettre à niveau (ajouter de l'espace de
          stockage ou des membres) ou rétrograder (supprimer de l'espace de
          stockage ou réduire le nombre de membres) le compte ou modifier la
          période d'abonnement à tout moment. L'administrateur peut annuler un
          compte personnel avec plusieurs utilisateurs à tout moment. En cas
          d'annulation, toutes les données stockées seront supprimées dans les
          90 jours suivant la date de résiliation.
        </p>
        <h3>5. Compte professionnel</h3>
        <p>
          Une entreprise, une organisation ou un individu peut créer un compte
          professionnel. Lorsqu'un compte professionnel est créé, un
          administrateur de compte professionnel est automatiquement créé.
          L'administrateur du compte professionnel est responsable de l'ajout et
          de la gestion du compte professionnel et de ses membres. Des
          conditions spécifiques s'appliquent aux comptes professionnels, voir
          la section 6 ci-dessous..
        </p>
        <h3>6. Conditions spéciales pour les comptes professionnelles</h3>
        <p>
          Si vous possédez un compte professionnel, ce chapitre (Conditions
          spéciales pour les comptes professionnels) s'applique à votre
          utilisation du Service. Un compte professionnel est créé par un
          administrateur de compte professionnel (« administrateur ») qui
          choisit le type d'abonnement professionnel, ajoute des membres du
          compte professionnel (« membres ») au compte et crée des comptes
          individuels pour chaque membre.
        </p>
        <p>
          L'administrateur identifie les membres du compte professionnel en
          fournissant les adresses e-mail de chaque membre. En tant
          qu'administrateur, vous êtes responsable du paiement des frais liés à
          l'utilisation du compte d'affaires par tous les membres.
          L'administrateur a le contrôle exclusif de la gestion de tous les
          comptes des membres et veille à ce que toute utilisation du Service
          soit conforme au présent Contrat et aux autres instructions de
          Jottacloud. Il est de la seule responsabilité de l'administrateur de
          s'assurer que la capacité de stockage des membres est augmentée ou
          réduite selon les besoins. L'administrateur est également responsable
          de l'ajout ou de la suppression de comptes individuels selon les
          besoins. Le bonus de stockage ne peut pas être cumulé pour les comptes
          professionnels.
        </p>
        <p>
          L'administrateur n'a pas accès aux données stockées sur les comptes
          des membres à moins qu'elles ne soient partagées avec
          l'administrateur. L'administrateur peut lire l'activité sur les
          comptes des membres et donc lire les noms des fichiers et des dossiers
          avec les fichiers téléchargés et d'autres informations relatives à
          l'activité du compte. Les membres n'ont accès qu'à leurs propres
          fichiers, sauf si les autres membres ont fichiers partagés avec eux.
          Les membres peuvent partager des données et des fichiers avec d'autres
          personnes. L'abonnement professionnel est automatiquement renouvelé
          tous les mois ou tous les ans, selon le choix de l'administrateur. Un
          administrateur peut mettre à niveau (ajouter de l'espace de stockage
          ou augmenter le nombre de comptes) ou rétrograder (supprimer de
          l'espace de stockage ou réduire le nombre de comptes) le compte ou
          modifier la période d'abonnement à tout moment. Ces modifications
          s'appliqueront à compter de la fin de la période d'abonnement en
          cours. L'administrateur peut annuler un compte professionnel à tout
          moment. En cas d'annulation, toutes les données stockées seront
          supprimées.
        </p>
        <h3>7. Licence d'utilisation du Service</h3>
        <p>
          Lorsqu'un utilisateur a créé un compte conformément aux conditions de
          la licence et aux instructions de Jottacloud, Jottacloud accorde à
          l'utilisateur le droit d'utiliser le Service.
        </p>
        <p>
          L'utilisateur ne doit utiliser le Service que dans le but, les limites
          et les instructions fournies par Jottacloud. Jottacloud vous accorde
          une licence non transférable pour installer et utiliser le Service aux
          fins spécifiées. La licence ne peut pas être transférée à des tiers ou
          mise à la disposition d'autres personnes au-delà de ce qui est indiqué
          dans le présent Contrat.
        </p>
        <p>
          Le code source appartenant à des tiers peut être fourni avec le
          Service et est soumis aux licences tierces applicables. Le Service et
          sa structure, son organisation, son code source et sa documentation
          contiennent des secrets commerciaux.
        </p>
        <p>
          Jottacloud est l'unique propriétaire du Service et du logiciel utilisé
          pour fournir le Service, ainsi que de toute la documentation associée.
        </p>
        <p>
          Le Service permet à l'utilisateur de partager, d'envoyer et d'échanger
          du contenu numérique avec d'autres personnes. L'utilisateur doit
          disposer de tous les droits nécessaires pour diffuser ce contenu
          numérique. En utilisant le Service, vous reconnaissez que Jottacloud
          n'a aucun contrôle sur le contenu numérique envoyé ou utilisé avec le
          Service, et que Jottacloud ne peut être tenu responsable de
          l'utilisation, du contenu ou du stockage de ce contenu numérique de
          quelque manière que ce soit.
        </p>
        <p>
          Jottacloud se conforme à tout moment à la législation norvégienne
          applicable et se réserve le droit de supprimer du contenu ou d'imposer
          d'autres restrictions jugées nécessaires pour garantir le respect des
          lois et réglementations applicables.
        </p>
        <p>
          Jottacloud se réserve le droit d'effectuer des tests antivirus et peut
          bloquer le téléchargement de certains fichiers.
        </p>
        <p>
          L'utilisateur ne peut pas faire un usage commercial du Service, y
          compris, mais sans s'y limiter, vendre ou distribuer le Service, le
          logiciel ou la documentation à un tiers.
        </p>
        <h3>8. Mettre à niveau et rétrograder</h3>
        <p>
          Vous pouvez passer d'un compte gratuit à un compte personnel ou à un
          abonnement Home en suivant les procédures de mise à niveau de
          Jottacloud. De même, vous pouvez passer d'un compte personnel ou d'un
          abonnement Home à un compte gratuit. La rétrogradation d'un compte
          signifie passer d'un compte personnel ou d'un abonnement Home à un
          compte gratuit. Avant de pouvoir effectuer une telle rétrogradation,
          vous devez supprimer les fichiers de votre compte personnel ou de
          votre abonnement Home afin que la quantité totale de données ne
          dépasse pas la limite de stockage actuelle d'un compte gratuit. Pour
          les comptes familiaux, vous devez également supprimer tous les autres
          membres avant de passer à un compte individuel ou gratuit.
        </p>
        <h3>9. Renouvellements, résiliation et annulation d'abonnement</h3>
        <p>
          Les abonnements pour les comptes personnels, les abonnements Home et
          les comptes professionnels sont automatiquement renouvelés à
          l'expiration d'une période d'abonnement. L'utilisateur peut résilier
          son abonnement à tout moment. Lorsqu'un abonnement est résilié, cela
          signifie qu'il ne sera pas renouvelé à la fin de la période
          d'abonnement. Après la résiliation d'un abonnement, Jottacloud
          clôturera le compte de l'utilisateur ou le rétrogradera en compte
          gratuit. Si le compte contient plus que la limite de stockage actuelle
          pour un compte gratuit, tous les fichiers du compte seront supprimés
          lors de cette rétrogradation. Vous pouvez supprimer votre compte
          utilisateur à tout moment. Cela peut être fait dans les paramètres,
          sur la page « Compte et profil ». Si l'utilisateur ne paie pas les
          frais ou autres montants dus à Jottacloud, Jottacloud a le droit de
          résilier le compte 90 jours après la date limite de paiement initiale.
          Un abonnement résilié sur cette base peut être résilié par Jottacloud
          après un délai de préavis, ce qui signifie que les fichiers et les
          données seront supprimés. Jottacloud a le droit de résilier le compte
          de l'utilisateur si celui-ci agit d'une manière non conforme au
          présent Contrat ou aux instructions données par Jottacloud. Nous
          supprimerons les données utilisateur dans les 90 jours suivant la
          résiliation du compte utilisateur.
        </p>
        <h3>10. Condition d'âge</h3>
        <p>
          L'âge minimum pour créer un compte gratuit, individuel ou familial est
          de 13 ans. Jottacloud a le droit de supprimer toutes les informations,
          y compris le compte utilisateur, les données et les fichiers s'il
          s'avère que l'utilisateur qui a créé le compte a moins de 13 ans. Pour
          les comptes familiaux, l'administrateur de la famille doit être âgé de
          plus de 13 ans.
        </p>
        <h3>11. Changements apportés aux informations personnelles</h3>
        <p>
          L'utilisateur doit immédiatement informer Jottacloud des modifications
          apportées à son adresse e-mail et à ses informations de paiement en
          mettant à jour les paramètres du compte dans Paramètres. L'utilisateur
          est seul responsable de tous les coûts pouvant découler de mises à
          jour incorrectes ou manquantes des informations utilisateur.
        </p>
        <h3>12. Confidentialité et collecte des données</h3>
        <p>
          Jottacloud peut collecter des informations non personnellement
          identifiables liées à l'utilisation du Service. Cela inclut les
          statistiques et les mesures de performance liées au logiciel. Ces
          informations sont envoyées à Jottacloud et ne peuvent être utilisées
          par Jottacloud que conformément à la Politique de confidentialité de
          Jottacloud. S'il existe une ordonnance judiciaire valide d'un tribunal
          norvégien, Jottacloud divulguera les données conformément à
          l'ordonnance du tribunal. Dans de tels cas, Jottacloud informera
          l'utilisateur s'il est légalement autorisé de le faire.
        </p>
        <h3>13. Stockage bonus</h3>
        <p>
          Vous pouvez gagner de l'espace de stockage gratuit supplémentaire («
          Stockage bonus ») sur votre compte. Le stockage bonus est un espace de
          stockage gratuit mis à disposition sur votre compte utilisateur
          pendant une période limitée. Le stockage bonus n'est disponible que
          pour les comptes gratuits et les comptes individuels. Jottacloud se
          réserve le droit d'annuler ou de modifier les conditions du stockage
          bonus.
        </p>
        <h3>14. Conditions d'utilisation du Service</h3>
        <p>
          Pour utiliser le Service, vous devez disposer d'un ordinateur et/ou
          d'un appareil mobile compatible avec accès à Internet. Si vous
          utilisez le Service via une connexion sans fil, cela peut entraîner
          des frais supplémentaires de la part de votre opérateur mobile. Vous
          êtes responsable du paiement de tous les coûts liés aux données et de
          tous les équipements et autres services tiers que vous utilisez pour
          accéder au Service.
        </p>
        <p>
          L'utilisateur est responsable de se souvenir de son mot de passe et de
          le garder confidentiel. L'utilisateur est responsable de toute
          activité qui se produit sous son nom d'utilisateur. Si l'utilisateur
          perd le mot de passe de son compte, il risque de ne pas pouvoir
          accéder à ses données. Le nom d'utilisateur et le mot de passe de
          l'utilisateur sont personnels et ne peuvent pas être partagés avec un
          tiers. Si l'utilisateur a connaissance d'une utilisation abusive de
          son compte, il doit en informer immédiatement Jottacloud.
        </p>
        <h3>15. Utilisation équitable et acceptable</h3>
        <p>
          Toute utilisation des produits et services de Jottacloud doit être
          conforme aux principes décrits dans le présent Contrat et aux lois et
          réglementations applicables. Jottacloud peut établir ou étendre des
          routines opérationnelles pour garantir la disponibilité du Service et
          empêcher toute utilisation abusive.
        </p>
        <p>
          Dans le cadre de ces routines opérationnelles, nous nous réservons le
          droit de surveiller nos systèmes afin d'identifier l'utilisation
          excessive des ressources de stockage et de réseau et de mettre en
          œuvre les mesures techniques et autres que nous jugeons nécessaires.
          Des restrictions sur la bande passante et le nombre d'appels d'API
          peuvent être mises en œuvre.
        </p>
        <p>
          L'abonnement Jottacloud personnel avec stockage illimité est conçu
          pour offrir au client une prévisibilité. Illimité fait référence à
          l'espace de stockage disponible. Si la quantité totale de stockage
          dépasse 5 To sur un abonnement personnel illimité, la vitesse de
          téléchargement sera progressivement réduite.
        </p>
        <p>
          Les utilisateurs disposant d'un compte personnel ou d'un abonnement
          Home peuvent utiliser le Service pour un usage non commercial normal.
          Nous nous réservons le droit d'empêcher toute utilisation excessive et
          abusive du Service.
        </p>
        <p>
          Si la consommation totale de stockage et de réseau d'un utilisateur
          est nettement supérieure à la consommation normale d'un utilisateur
          moyen de Jottacloud, et/ou indique que le Service est utilisé pour
          autre chose qu'un usage personnel et non commercial, cela peut être
          considéré comme une mauvaise utilisation du service.
        </p>
        <p>
          Dans les cas mentionnés ci-dessus, nous nous réservons le droit de
          proposer un abonnement alternatif à Jotta, de mettre fin à la relation
          client ou de supprimer le compte et/ou les données de l'utilisateur.
          Nous contacterons l'utilisateur avec une proposition de modification
          ou un avis d'action dans de tels cas.
        </p>
        <p>
          Les utilisateurs ne peuvent pas revendre des comptes ou l'un des
          services du compte. Vous ne pouvez pas partager votre mot de passe
          avec un tiers et vous devez le stocker de manière sécurisée et
          appropriée. L'utilisation des services et/ou des produits de
          Jottacloud pour des activités illégales constitue une violation de cet
          accord.
        </p>
        <p>
          Vous ne pouvez pas stocker et/ou distribuer sur le Service des données
          qui enfreignent les lois et réglementations norvégiennes, y compris
          les lois sur la confidentialité et les droits d'auteur. Cela inclut la
          pornographie enfantine, le matériel piraté et/ou tout autre matériel
          illégal ou protégé par des droits d'auteur.
        </p>
        <p>
          Les comptes utilisateurs utilisés pour stocker et/ou partager du
          matériel illégal ou protégé par des droits d'auteur sur le Service
          seront résiliés. Jottacloud se réserve le droit de bloquer l'accès ou
          d'interdire l'utilisation du Service, de supprimer les données des
          utilisateurs et/ou de supprimer les comptes utilisateurs si nous
          estimons que l'utilisateur enfreint le présent Contrat.
        </p>
        <p>
          Le stockage et/ou la distribution de données qui enfreignent la loi
          norvégienne peuvent être signalés aux autorités.
        </p>
        <h3>16. Responsabilité et garanties</h3>
        <p>
          La responsabilité totale de Jottacloud pour toute forme de dommage, de
          coût ou de perte lié au Service, y compris la perte de données, est en
          tout état de cause limitée à un montant équivalent aux frais payés
          pour le compte concerné au cours des 12 derniers mois précédant la
          survenance de la réclamation. Jottacloud n'est responsable d'aucune
          forme de perte indirecte ou consécutive. Ces limitations sont
          convenues par les parties et s'appliquent sauf disposition légale
          contraire.
        </p>
        <h3>17. Marketing et communication sur les canaux électroniques</h3>
        <p>
          Jottacloud n'enverra à l'utilisateur des informations pertinentes et
          personnalisées sur les actualités, les produits et les services de
          l'entreprise par le biais de canaux tels que le courrier électronique
          et les SMS que si l'utilisateur a donné son consentement.
          L'utilisateur peut retirer ce consentement à tout moment.
        </p>
        <h3>
          18. Modifications apportées au Service et aux Conditions d'utilisation
        </h3>
        <p>
          Jottacloud se réserve le droit de modifier les termes et conditions du
          Contrat avec un préavis de 30 (trente) jours. Jottacloud se réserve
          également le droit d'interrompre, de modifier ou de résilier le
          Service, en tout ou en partie, après en avoir informé l'utilisateur
          par e-mail au moins 30 (trente) jours avant cette modification ou
          résiliation du Service. Jottacloud se réserve le droit de modifier les
          prix des abonnements en cours. Les modifications entreront en vigueur
          30 (trente) jours après l'envoi de la notification. Toutes les
          notifications de modifications mentionnées ci-dessus seront envoyées à
          l'utilisateur par e-mail.
        </p>
        <h3>19. Droit d'annulation</h3>
        <p>
          L'utilisateur dispose d'un délai de 14 (quatorze) jours après l'achat
          du Service pour annuler le Service sans aucune autre obligation pour
          l'utilisateur. Le droit d'annulation n'est disponible que pour les
          comptes personnels.
        </p>
        <h3>20. Divers</h3>
        <p>
          Jottacloud se réserve le droit de transférer cet accord à un tiers.
          Jottacloud informera les utilisateurs d'un tel changement.
          L'utilisateur sera informé 3 (trois) jours à l'avance par e-mail.
        </p>
        <h3>21. Loi applicable et résolution des litiges</h3>
        <p>
          Le présent Contrat est régi et interprété conformément au droit
          norvégien. Les parties conviennent que le tribunal de district d'Oslo
          est le lieu approprié.
        </p>
        <h3>22. Service client</h3>
        <p>
          Pour toute question concernant le Service, contactez le service client
          par e-mail à l'adresse support@jottacloud.com. Jottacloud s'efforcera
          de répondre à toutes les demandes dans un délai raisonnable.
        </p>
        <h3>23. Informations de contact e-mail :</h3>
        <p>support@jottacloud.com, Jotta AS Øvre Slottsgate 5</p>
      </div>
    </article>
  )
}
